export class CArticle {
    fId: number;
    fDataCreatedOn: string;
    fDateCreatedOnPersian: string;
    fDateLastUpdate: string;
    fDateLastUpdatePersian: string;
    fUserIdCreator: string;
    fUserIdEditor: string;
    fSubject: string;
    fDescription: string;
    fFullText: string;
    fImageAddressHighQuality: string;
    fImageAddressLowQuality: string;
    fMetaDescription: string;
    fMetaKeywords: string;
    fShowInSecondPart: boolean;
    fUrlTitle: string;

    constructor() {
        this.fId = 0;
        this.fDataCreatedOn = "";
        this.fDateCreatedOnPersian = "";
        this.fDateLastUpdate = "";
        this.fDateLastUpdatePersian = "";
        this.fUserIdCreator = "";
        this.fUserIdEditor = "";
        this.fSubject = "";
        this.fDescription = "";
        this.fFullText = "";
        this.fImageAddressHighQuality = "";
        this.fImageAddressLowQuality = "";
        this.fMetaDescription = "";
        this.fMetaKeywords = "";
        this.fShowInSecondPart = false;
        this.fUrlTitle = "";
    }
}